const STORAGE_KEY = 'pingping_post_auth_path';

function sanitizeInternalPath(path) {
  if (typeof path !== 'string' || !path.startsWith('/') || path.startsWith('//')) return '/';
  return path;
}

/** OAuth 직전 호출: 로그인 후 돌아올 경로(예: /claim/:token). 오픈 리다이렉트 방지로 `/` 로만 시작하는 경로만 허용 */
export function setPostAuthRedirect(pathnameAndSearch) {
  const path = sanitizeInternalPath(pathnameAndSearch || '/');
  try {
    sessionStorage.setItem(STORAGE_KEY, path);
  } catch {
    /* ignore */
  }
}

export function consumePostAuthRedirect(fallback = '/') {
  try {
    const v = sessionStorage.getItem(STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_KEY);
    return sanitizeInternalPath(v || fallback);
  } catch {
    /* ignore */
  }
  return sanitizeInternalPath(fallback);
}
